import { useState } from 'react';
import WishlistProvider from './hooks/useWishlist';

import { WishlistProps } from './@types/WishlistProps';
import WishlistContainer from './handles/WishlistContainer';
import { VtexButton } from '../../../styleguide/VtexButton';
import WishlistIcon from './handles/WishlistIcon';

import './Wishlist.scss';

const Wishlist = (props: WishlistProps) => {
	const [fill, setFill] = useState<boolean>(false);

	return (
		<WishlistProvider {...props}>
			<WishlistContainer>
				<VtexButton variation="tertiary" handleClick={() => setFill(!fill)}>
					<WishlistIcon fill={fill} />
				</VtexButton>
			</WishlistContainer>
		</WishlistProvider>
	);
};

export default Wishlist;
